module.exports = __webpack_public_path__ + "static/Image_Left@2x-4bbf117e9dcaf369f1efaf76b410b550.png";